var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        title: _vm.title,
        description: _vm.description,
        label: "Create",
        submitLoading: _vm.submitLoading,
        disabled: _vm.isDisabledSubmit
      },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onSubmit
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "flex flex-col gap-5 px-8",
          class: { "overflow-y-auto": _vm.typeInput },
          style: { width: "48rem", maxHeight: "calc(100vh - 14rem)" }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "grid items-center grid-cols-6 gap-4 py-4 target-details"
            },
            [
              _c(
                "div",
                { staticClass: "col-span-6" },
                [_c("BlTextSubtitle1", { attrs: { text: "Details" } })],
                1
              ),
              _vm._v(" "),
              _c("BlInputText", {
                staticClass: "col-span-6",
                attrs: { input: _vm.titleInput },
                on: { changed: _vm.inputHandler }
              }),
              _vm._v(" "),
              _c("BlSelectBox", {
                staticClass: "col-span-3",
                attrs: {
                  label: "Data collection method",
                  asterisk: "",
                  placeholder: "Select type",
                  options: _vm.typeOptions
                },
                on: {
                  change: function($event) {
                    _vm.typeInput = $event
                  }
                },
                model: {
                  value: _vm.typeInput,
                  callback: function($$v) {
                    _vm.typeInput = $$v
                  },
                  expression: "typeInput"
                }
              }),
              _vm._v(" "),
              _c("BlSelectBox", {
                staticClass: "col-span-3",
                attrs: {
                  label: "Curriculum",
                  asterisk: "",
                  search: "",
                  placeholder: "Select curriculum",
                  options: _vm.defaultCurriculumOptions,
                  fetchProperty: {
                    url:
                      "/api/v1/curriculums?databank_id=" +
                      this.$route.params.id +
                      "&sort=name_asc&query=",
                    dataKey: "curriculums",
                    countKey: "total_count",
                    optionKeys: {
                      value: "id",
                      label: "name",
                      prefixColor: "color"
                    }
                  },
                  disabled: !!_vm.defaultCurriculum
                },
                on: {
                  change: function($event) {
                    _vm.curriculumIdInput = $event
                  }
                },
                model: {
                  value: _vm.curriculumIdInput,
                  callback: function($$v) {
                    _vm.curriculumIdInput = $$v
                  },
                  expression: "curriculumIdInput"
                }
              }),
              _vm._v(" "),
              _c("BlInputText", {
                staticClass: "col-span-6",
                attrs: { input: _vm.descriptionInput },
                on: { changed: _vm.inputHandler }
              }),
              _vm._v(" "),
              _vm.typeInput.includes("Pir")
                ? _c("BlInputText", {
                    staticClass: "col-span-3",
                    attrs: { input: _vm.intervalInput },
                    on: { changed: _vm.inputHandler }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.typeInput.includes("Pir")
                ? _c("BlInputText", {
                    staticClass: "col-span-3",
                    attrs: { input: _vm.durationInput },
                    on: { changed: _vm.inputHandler }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.typeInput.includes("Percentage") ||
              _vm.typeInput.includes("Pir")
                ? _c("BlInputText", {
                    staticClass: "col-span-3",
                    attrs: { input: _vm.goalInput },
                    on: { changed: _vm.inputHandler }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.typeInput.includes("Duration")
                ? _c("BlInputTime", {
                    staticClass: "col-span-3",
                    attrs: { input: _vm.timeInput },
                    on: { changed: _vm.inputHandler }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.typeInput.includes("Frequency")
                ? _c("BlInputText", {
                    staticClass: "col-span-3",
                    attrs: { input: _vm.goalFrequencyInput },
                    on: { changed: _vm.inputHandler }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.typeInput.includes("Prompting")
                ? _c("div", { staticClass: "flex flex-col col-span-6" }, [
                    _c(
                      "label",
                      {
                        staticClass:
                          "relative w-full mb-1 text-sm leading-relaxed text-grey"
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s("Goal and success metric") +
                            "\n          "
                        ),
                        _c(
                          "span",
                          {
                            staticClass:
                              "absolute ml-1 text-xl text-error-400 -top-2"
                          },
                          [_vm._v("*")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "flex flex-wrap items-center gap-1 text-sm"
                      },
                      [
                        _c("BlTextBody2", {
                          attrs: { text: "Achieve target with" }
                        }),
                        _vm._v(" "),
                        _c("BlSelectBox", {
                          staticClass: "max-w-48",
                          attrs: {
                            dense: "",
                            placeholder: "Select success metric",
                            options: _vm.defaultPrompts.map(function(i) {
                              return { value: i.name, label: i.name }
                            })
                          },
                          on: {
                            change: function($event) {
                              _vm.successMetricInput = $event
                            }
                          },
                          model: {
                            value: _vm.successMetricInput,
                            callback: function($$v) {
                              _vm.successMetricInput = $$v
                            },
                            expression: "successMetricInput"
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: { text: "prompt, minimum" }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.goalPromptInput,
                              expression: "goalPromptInput"
                            }
                          ],
                          staticClass:
                            "w-10 h-8 px-2 text-center border rounded outline-none border-grey-200 text-grey focus:border-light-purple",
                          attrs: { type: "number" },
                          domProps: { value: _vm.goalPromptInput },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.goalPromptInput = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: { text: "attempt(s) per session." }
                        })
                      ],
                      1
                    )
                  ])
                : _vm.typeInput
                ? _c("BlSelectBox", {
                    staticClass: "col-span-3",
                    attrs: {
                      label: "Success metric",
                      asterisk: "",
                      placeholder: "Select success metric",
                      options: _vm.successMetricOptions
                    },
                    on: {
                      change: function($event) {
                        _vm.successMetricInput = $event
                      }
                    },
                    model: {
                      value: _vm.successMetricInput,
                      callback: function($$v) {
                        _vm.successMetricInput = $$v
                      },
                      expression: "successMetricInput"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.typeInput.includes("Percentage")
                ? _c("BlInputText", {
                    staticClass: "col-span-3",
                    attrs: { input: _vm.trialsInput },
                    on: { changed: _vm.inputHandler }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.typeInput.includes("Prompting")
            ? _c(
                "div",
                { staticClass: "flex flex-col gap-2 py-4 prompt-selection" },
                [
                  _c("BlTextSubtitle1", {
                    attrs: { text: "Prompt selection" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "Choose or customize prompts for this target; each symbol represents a specific prompt on the graph. You can personalize the card later, before each session, by disabling specific prompts to create a simplified card based on your preferences!"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center p-4 border rounded bg-grey-100 h-76 border-grey-200"
                    },
                    [
                      _c("PromptPreview", {
                        style: { transform: "scale(0.5 , 0.5)" },
                        attrs: { prompts: _vm.defaultPrompts }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex flex-col gap-2 mx-6" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-center gap-4" },
                        [
                          _c("div", { staticClass: "flex-shrink-0 w-2" }),
                          _vm._v(" "),
                          _c("BlTextSubtitle4", {
                            staticClass: "w-full",
                            attrs: { text: "Prompt name" }
                          }),
                          _vm._v(" "),
                          _c("BlTextSubtitle4", {
                            staticClass: "flex-shrink-0 w-15",
                            attrs: { text: "Code" }
                          }),
                          _vm._v(" "),
                          _c("BlTextSubtitle4", {
                            staticClass: "flex-shrink-0 w-24",
                            attrs: { text: "Symbol" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex-shrink-0 w-6" })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "draggable",
                        {
                          staticClass: "mb-2 space-y-4",
                          attrs: { handle: ".handle" },
                          on: {
                            update: function($event) {
                              $event.preventDefault()
                              return _vm.onMovePosition($event)
                            }
                          }
                        },
                        _vm._l(
                          _vm.onSort(_vm.defaultPrompts, "position"),
                          function(prompt) {
                            return _c(
                              "div",
                              {
                                key: prompt.id + "-" + prompt.position,
                                staticClass: "flex items-center gap-4",
                                attrs: { id: prompt.id }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center justify-center flex-shrink-0 w-2 text-sm cursor-move handle text-grey-400"
                                  },
                                  [
                                    _c("BlIcon", {
                                      staticClass: "flex-shrink-0 w-4",
                                      attrs: { icon: "drag" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("PromptItem", {
                                  attrs: {
                                    prompt: prompt,
                                    directDelete: true,
                                    disabledDelete: _vm.isUsedToSuccessMetric(
                                      prompt.name
                                    ),
                                    tooltipDelete: _vm.isUsedToSuccessMetric(
                                      prompt.name
                                    )
                                      ? "You cannot delete this prompt because it has been used as a success metric."
                                      : ""
                                  },
                                  on: {
                                    update: _vm.onUpdatePrompt,
                                    delete: _vm.onRemovePrompt
                                  }
                                })
                              ],
                              1
                            )
                          }
                        ),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c("BlInputButton", {
                            staticClass: "px-0",
                            attrs: {
                              icon: "plus",
                              label: "Add prompt",
                              type: "plain"
                            },
                            on: { clicked: _vm.onAddPrompt }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.typeInput.includes("Percentage")
            ? _c(
                "div",
                { staticClass: "flex flex-col gap-2 py-4 probing" },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-center" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "pl-2 pr-4",
                          style: { transform: "scale(1.375)" }
                        },
                        [
                          _c("BlInputToggle", {
                            attrs: { checked: _vm.probingEnableInput },
                            on: {
                              changed: function($event) {
                                _vm.probingEnableInput = !_vm.probingEnableInput
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("BlTextSubtitle1", { attrs: { text: "Probing" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "Probing can be employed to assess a skill at various stages of the therapy. Activating probing gives you additional option to conduct probes during the session."
                    }
                  }),
                  _vm._v(" "),
                  _vm.probingEnableInput
                    ? _c(
                        "div",
                        { staticClass: "grid grid-cols-6 gap-4" },
                        [
                          _c("BlInputText", {
                            staticClass: "col-span-3",
                            attrs: { input: _vm.probingTrialInput },
                            on: { changed: _vm.inputHandler }
                          }),
                          _vm._v(" "),
                          _c("BlInputText", {
                            staticClass: "col-span-3",
                            attrs: { input: _vm.probingGoalInput },
                            on: { changed: _vm.inputHandler }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.typeInput
            ? _c(
                "div",
                {
                  staticClass: "flex flex-col gap-2 py-4 action-recommendation"
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-2" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "p-1 bg-orange-300",
                          style: { borderRadius: "4px" }
                        },
                        [
                          _c("BlIcon", {
                            staticClass: "w-5 h-5",
                            attrs: { icon: "tooltip" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("BlTextSubtitle1", {
                        attrs: { text: "Action recommendations" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "Below are the targets that have successfully reached their success metrics and may need further action."
                    }
                  }),
                  _vm._v(" "),
                  _c("ActionRecommendationInput", {
                    attrs: {
                      navigateSuccessMetric: false,
                      totalSuccess: _vm.totalSuccessInput,
                      consecutiveSuccess: _vm.consecutiveSuccessInput
                    },
                    on: {
                      input: function($event) {
                        return _vm.onInputActionRecommendation($event)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a47cfa4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a47cfa4c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/superAdmin/databank/NewTargetModal.vue
// module id = null
// module chunks = 